<template>
  <v-container grid-list-xs>
    <v-card>
      <v-tabs
        v-model="tabNews"
        color="deep-purple-accent-4"
        align-tabs="center"
      >
        <v-tab value="unread">Não lidos</v-tab>
        <v-tab value="news">Todas as notícias</v-tab>
      </v-tabs>
      <v-window v-model="tabNews">
        <v-window-item value="unread">
          <v-data-table
            :headers="headers"
            :items="lstObjects"
            :items-per-page="filters.itemsPerPage"
            return-object
            class="elevation-1"
            hide-default-footer
            :loading="requestingApi"
          >
            <template v-slot:bottom>
              <div class="text-center pt-2">
                <v-pagination
                  :disabled="requestingApi"
                  v-model="page"
                  :length="maxPage"
                ></v-pagination>
              </div>
            </template>
            <template v-slot:item.receivers="{ item }">
              <div>
                <v-chip
                  class="mr-2"
                  rounded
                  v-for="(receiver, ixreceiver) in item.receivers"
                  :key="ixreceiver"
                >
                  {{ receiver?.legal_person?.name }}
                </v-chip>
              </div>
            </template>
            <template v-slot:item.updated_at="{ item }">
              <span>{{
                $moment(item.schedule || item.updated_at).format(
                  "DD/MM/YYYY"
                )
              }}</span>
            </template>
            <template v-slot:item.attachments="{ item }">
              <v-menu v-if="item.attachments">
                <template v-slot:activator="{ props }">
                  <v-btn icon variant="text" color="secondary" v-bind="props"
                    ><v-icon>mdi-paperclip</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(attachment, ixattach) in item.attachments"
                    :key="ixattach"
                    @click="downloadFile(attachment?.file)"
                  >
                    <v-list-item-title>
                      <v-icon color="secondary" class="mr-2"
                        >mdi-download</v-icon
                      >
                      {{ attachment?.file?.name }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <span v-else>---</span>
            </template>
            <template v-slot:item.actions="{ index, internalItem }">
              <DialogViewNews v-model="internalItem.raw" @viewed="lstObjects.splice(index,1)"/>
            </template>
          </v-data-table>
        </v-window-item>
        <v-window-item value="news">
          <v-row>
            <v-col cols="12">
              <v-form :submit="submitSearch">
                <v-card color="grey-lighten-2">
                  <v-card-title>
                    Filtro de pesquisa
                    <DialogCreateUpdateNews
                      :user="user"
                      v-if="canCreate"
                      v-model="editModel"
                      :floatRight="true"
                      @created="createdNews"
                    />
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          v-model="filters.searchText"
                          label="Nome"
                          clearable
                          density="compact"
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="4" md="3">
                        <v-select
                          :items="[50, 100, 200, 500]"
                          v-model="filters.itemsPerPage"
                          label="Resultados por página"
                          density="compact"
                          hide-details
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-card-actions>
                      <v-btn color="warning" @click="clearFilters()"
                        ><v-icon class="mr-2">mdi-broom</v-icon>Limpar
                        pesquisa</v-btn
                      >
                      <v-spacer></v-spacer>
                      <v-btn color="primary" type="submit">
                        <v-icon class="mr-2">mdi-magnify</v-icon>
                        Pesquisar
                      </v-btn>
                    </v-card-actions>
                  </v-card-text>
                </v-card>
              </v-form>
            </v-col>
            <v-col cols="12">
              <v-card>
                <v-card-title>
                  Notícias
                  <v-spacer></v-spacer>
                </v-card-title>
                <v-data-table
                  :headers="headers"
                  :items="lstObjects"
                  :items-per-page="filters.itemsPerPage"
                  return-object
                  class="elevation-1"
                  hide-default-footer
                  :loading="requestingApi"
                >
                  <template v-slot:bottom>
                    <div class="text-center pt-2">
                      <v-pagination
                        :disabled="requestingApi"
                        v-model="page"
                        :length="maxPage"
                      ></v-pagination>
                    </div>
                  </template>
                  <template v-slot:item.receivers="{ value }">
                    <div>
                      <v-chip
                        class="mr-2"
                        rounded
                        v-for="(receiver, ixreceiver) in value"
                        :key="ixreceiver"
                      >
                        {{ receiver?.legal_person?.name }}
                      </v-chip>
                    </div>
                  </template>
                  <template v-slot:item.updated_at="{ item }">
                    <span>{{
                      $moment(item.schedule || item.updated_at).format(
                        "DD/MM/YYYY"
                      )
                    }}</span>
                  </template>
                  <template v-slot:item.attachments="{ value }">
                    <v-menu v-if="value">
                      <template v-slot:activator="{ props }">
                        <v-btn
                          icon
                          variant="text"
                          color="secondary"
                          v-bind="props"
                          ><v-icon>mdi-paperclip</v-icon></v-btn
                        >
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(attachment, ixattach) in value"
                          :key="ixattach"
                          @click="downloadFile(attachment?.file)"
                        >
                          <v-list-item-title>
                            <v-icon color="secondary" class="mr-2"
                              >mdi-download</v-icon
                            >
                            {{ attachment?.file?.name }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <span v-else>---</span>
                  </template>
                  <template v-slot:item.actions="{ internalItem }">
                    <DialogViewNews v-model="internalItem.raw"/>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-window-item>
      </v-window>
    </v-card>
  </v-container>
</template>
<script>
import DialogViewNews from '@/components/DialogViewNews.vue';
import api from '@/services'
export default {
  components: {DialogViewNews},
  props: {
    user: Object,
  },
  data() {
    return {
      requestingApi: false,
      tabNews: "unread",
      headers: [
        { title: "id", align: "start", key: "id", sortable: false },
        { title: "Título", align: "start", key: "name", sortable: false },
        { title: "Data", align: "start", key: "updated_at", sortable: false },
        {
          title: "Destinatário",
          align: "start",
          key: "receivers",
          sortable: false,
        },
        {
          title: "Anexos",
          align: "center",
          key: "attachments",
          sortable: false,
        },
        { title: "", key: "actions", align: "end", sortable: false },
      ],
      lstObjects: [],
      filters: {
        searchText: null,
        itemsPerPage: 15,
      },
      page: 1,
      maxPage: 1,
    };
  },
  created() {
    var vm = this;
    vm.loadParameters();
    vm.submitSearch();
  },
  mounted() {},
  activated() {},
  methods: {
    downloadFile(file) {
      window.open(file.path, "_blank");
    },
    loadParameters() {
      var vm = this;
      let _itemsPerPage = localStorage["_news_itemsPerPage"];
      let _unread = localStorage["_news_unread"];
      let _tab = localStorage["_news_tab"];
      vm.filters.itemsPerPage = parseInt(_itemsPerPage || 10);
      vm.filters.unread = _unread ? true : false;
      vm.tabNews = _tab || "unread";
    },
    clearFilters() {
      var vm = this;
      vm.filters.searchText = null;
    },
    submitSearch(page) {
      var vm = this;
      if (!vm.requestingApi) {
        vm.requestingApi = true;
        vm.page = page || 1;
        return new Promise((resolve, reject) => {
          let _filters = [];
          if (vm.filters?.searchText) {
            _filters.push(`name=${vm.filters.searchText}`);
          }
          if (vm.filters?.itemsPerPage) {
            _filters.push(`itemsPerPage=${vm.filters.itemsPerPage}`);
          }
          if (vm.tabNews == "unread") {
            _filters.push(`unread=1`);
          }
          api.news
            .myNews(_filters, page || 1)
            .then((result) => {
              vm.lstObjects = result || [];
              vm.maxPage = Math.ceil(
                (result?.total || 1) / (result?.per_page || 10)
              );
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
  },
  computed: {},
  watch: {
    "filters.itemsPerPage"(newVal) {
      localStorage["_news_itemsPerPage"] = newVal;
    },
    "filters.unread"(newVal) {
      localStorage["_news_unread"] = newVal || "";
    },
    tabNews(newVal) {
      localStorage["_news_tab"] = newVal || "unread";
      this.submitSearch();
    },
    page(newVal) {
      var vm = this;
      if (!isNaN(newVal)) {
        vm.submitSearch(newVal);
      }
    },
  },
};
</script>